import {
   type UseQueryOptions,
   type UseMutationOptions,
   useQuery as useQuery_,
   useMutation as useMutation_,
} from "@tanstack/react-query";

export { useInfiniteQuery } from "@tanstack/react-query";

export type UseQueryKey =
   // User
   | ["CREATE_USER", string]
   | ["UPDATE_USER", string, number | string]
   | ["FETCH_USERS", string]
   | ["FETCH_USER", string, string]
   | ["FETCH_CURRENT_USER", string]
   | ["UPDATE_CURRENT_USER", string]
   // Application
   | ["FETCH_APPLICATIONS", ...string[]]
   | ["FETCH_OVERDUE_APPLICATIONS", string]
   | ["FETCH_APPLICATION", string, number | string]
   | ["UPDATE_APPLICATION", string, number | string]
   // EMI
   | ["FETCH_EMIS", string, number | string]
   | ["UPDATE_EMI", string, number | string, number | string]
   | ["FETCH_REVERSED_EMI", string, number | string, number | string]
   | ["UPDATE_REVERSED_EMI", string, number | string, number | string]
   | ["FETCH_SCHEDULED_EMIS", string, number | string]
   // Workspace
   | ["FETCH_WORKSPACES"]
   | ["CREATE_WORKSPACE", string]
   | ["UPDATE_WORKSPACE", string, number | string]
   | ["FETCH_WORKSPACE", string]
   // Transaction
   | ["FETCH_TRANSACTIONS", string]
   | ["FETCH_TRANSACTION", string, number | string]
   | ["CREATE_TRANSACTION", string]
   | ["UPDATE_TRANSACTION", string, number | string]
   // Collection
   | ["FETCH_COLLECTIONS", string]
   | ["FETCH_COLLECTIONS", string, string];

interface UseQueryProps<TData>
   extends Omit<UseQueryOptions<TData>, "queryKey"> {
   queryKey: UseQueryKey;
}

interface UseMutationProps<TData, TErrors, TVariables, TReturn>
   extends Omit<
      UseMutationOptions<TData, TErrors, TVariables, TReturn>,
      "mutationKey"
   > {
   mutationKey: UseQueryKey;
}

export function useQuery<TData = unknown>(props: UseQueryProps<TData>) {
   return useQuery_({ ...props, refetchOnWindowFocus: false });
}

export function useMutation<
   TData = unknown,
   TErrors = Error,
   TVariables = void,
   TReturn = unknown,
>(props: UseMutationProps<TData, TErrors, TVariables, TReturn>) {
   return useMutation_(props);
}
